import { ClaudeCodeSDKService } from './claudeCodeSDK';

export async function testSDKIntegration(projectPath: string): Promise<{
  success: boolean;
  message: string;
  details?: any;
}> {
  try {
    console.log('Testing Byte DevOps SDK integration...');
    
    const config = {
      projectPath,
      model: 'claude-3-5-sonnet-20241022',
      maxTurns: 3,
      allowedTools: ['Read', 'Glob']
    };

    const sdkService = new ClaudeCodeSDKService(config);
    
    // Test basic message sending
    const response = await sdkService.sendMessage('Hello, can you help me test the SDK integration?');
    
    if (response.messages.length === 0) {
      return {
        success: false,
        message: 'No messages received from SDK'
      };
    }

    // Check for system init message
    const systemMessage = response.messages.find(msg => 
      msg.type === 'system' && msg.subtype === 'init'
    );

    if (!systemMessage) {
      return {
        success: false,
        message: 'No system initialization message received'
      };
    }

    // Check for assistant response
    const assistantMessage = response.messages.find(msg => 
      msg.type === 'assistant'
    );

    if (!assistantMessage) {
      return {
        success: false,
        message: 'No assistant response received'
      };
    }

    return {
      success: true,
      message: 'SDK integration test successful',
      details: {
        sessionId: response.sessionId,
        messageCount: response.messages.length,
        totalCost: response.totalCost,
        duration: response.duration,
        tools: systemMessage.tools || [],
        model: systemMessage.model || 'unknown'
      }
    };

  } catch (error) {
    console.error('SDK integration test failed:', error);
    return {
      success: false,
      message: `SDK test failed: ${error instanceof Error ? error.message : 'Unknown error'}`,
      details: { error: error instanceof Error ? error.stack : String(error) }
    };
  }
}

// Helper function to run SDK test from browser console
export function runSDKTest(projectPath?: string): void {
  const testPath = projectPath || '/Users/intars/Documents/ByteRnD/claude-code-sdk/projects/test';
  
  testSDKIntegration(testPath).then(result => {
    console.log('SDK Test Result:', result);
    
    if (result.success) {
      console.log('✅ SDK Integration Working!');
      console.log('Session ID:', result.details?.sessionId);
      console.log('Available Tools:', result.details?.tools);
      console.log('Model:', result.details?.model);
    } else {
      console.log('❌ SDK Integration Failed:', result.message);
      if (result.details?.error) {
        console.error('Error details:', result.details.error);
      }
    }
  });
}

// Make it available globally for testing
if (typeof window !== 'undefined') {
  (window as any).runSDKTest = runSDKTest;
}
